"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const CommissionSamples_1 = require("./CommissionSamples");
const _1 = require(".");
function default_1({ insertTemplate, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-bg", css: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            padding: '10px 12px',
            borderRadius: '8px',
        } }, { children: [(0, jsx_runtime_1.jsx)(_1.ContentsTemplateTooltip, { templateName: t('저작권'), TemplateContents: CommissionSamples_1.CopyrightSample, insertTemplate: insertTemplate }), (0, jsx_runtime_1.jsx)(_1.ContentsTemplateTooltip, { templateName: t('타입 안내'), TemplateContents: CommissionSamples_1.TypeGuideSample, insertTemplate: insertTemplate }), (0, jsx_runtime_1.jsx)(_1.ContentsTemplateTooltip, { templateName: t('작업 안내'), TemplateContents: CommissionSamples_1.OperationGuideSample, insertTemplate: insertTemplate }), (0, jsx_runtime_1.jsx)(_1.ContentsTemplateTooltip, { templateName: t('폰디 이용방법'), TemplateContents: CommissionSamples_1.FondeeUsageGuideSample, insertTemplate: insertTemplate })] })));
}
exports.default = default_1;
